import React from 'react';
import { focusReducer, getInitialState, FocusContext } from '../utils';
export const FocusProvider = ({ children, search, header, options, preventFocus, }) => {
    const initialState = getInitialState(search, header, options, preventFocus);
    const [state, dispatch] = React.useReducer(focusReducer, initialState);
    return (React.createElement(FocusContext.Provider, { value: { focusState: state, focusDispatch: dispatch } }, children));
};
//# sourceMappingURL=FocusProvider.js.map